module.exports = __webpack_public_path__ + "static/img/nav_bg.7e99158f.png";